// <auto-generated />
// ATENCAO: Arquivo auto-gerado pelo SetupController. Nao altere manualmente.

export const PARCEIRO_ESFERA_GOV = {
  Municipal: 'PARCEIRO_ESFERA_GOV1',
  Federal: 'PARCEIRO_ESFERA_GOV2',
  Estadual: 'PARCEIRO_ESFERA_GOV3',
  ComiteGestor: 'PARCEIRO_ESFERA_GOV4',
  // Mapa de sequencia (SequenciaLista) para lookup por codigo
  sequencia: {
    PARCEIRO_ESFERA_GOV1: 1,
    PARCEIRO_ESFERA_GOV2: 2,
    PARCEIRO_ESFERA_GOV3: 3,
    PARCEIRO_ESFERA_GOV4: 4
  }
}
